import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CardTemplateMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardTemplateMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorBlind"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CardTemplateMember","document":CardTemplateMemberDocument}} as const;
export type CardTemplateMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type CardTemplateMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Member_Prefs' }
      & Pick<Types.Member_Prefs, 'colorBlind'>
    )> }
  )> }
);

/**
 * __useCardTemplateMemberQuery__
 *
 * To run a query within a React component, call `useCardTemplateMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardTemplateMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardTemplateMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCardTemplateMemberQuery(
  baseOptions: TrelloQueryHookOptions<
    CardTemplateMemberQuery,
    CardTemplateMemberQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: CardTemplateMemberDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    CardTemplateMemberQuery,
    CardTemplateMemberQueryVariables
  >(CardTemplateMemberDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useCardTemplateMemberLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    CardTemplateMemberQuery,
    CardTemplateMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CardTemplateMemberQuery,
    CardTemplateMemberQueryVariables
  >(CardTemplateMemberDocument, options);
}
export type CardTemplateMemberQueryHookResult = ReturnType<
  typeof useCardTemplateMemberQuery
>;
export type CardTemplateMemberLazyQueryHookResult = ReturnType<
  typeof useCardTemplateMemberLazyQuery
>;
export type CardTemplateMemberQueryResult = Apollo.QueryResult<
  CardTemplateMemberQuery,
  CardTemplateMemberQueryVariables
>;
